module.exports = __webpack_public_path__ + "static/media/Logo_Small_Transparent.8779a170.png";